<template>
  <div class="landing">
    <!--intro-->
    
    <!-- benefits -->
    
    
    <!--how-->
    <div class="landing-flat">
      <div class="landing__container">
        <ol class="landing-how">
          <li class="landing-how__item" v-view>
            <div class="landing-how__title">
              <!-- Request an invite to NEO ONE art through our website or scanning this QR code -->
              HP上から、もしくはこちらのQRコードをスキャンして、NEO ONE artに「招待」をリクエストします。
            </div>
            <figure class="landing-how__figure">
              <img src="../assets/howtoclaim/QR-invitation.png" />
              <!-- <p>
                {{ $t("homeStep1Text") }}
              </p> -->
            </figure>
          </li>
          <li class="landing-how__item" v-view>
            <div class="landing-how__title">
              <!-- Once you receive the invitation in your email, click on "Register" and register on our website -->
              お客様のe-mailに招待状が届きますので、「登録」を押していただき、HPより登録をお済ませください。
            </div>
            <figure class="landing-how__figure">
              <img src="../assets/howtoclaim/invitation-ja.png" />
              <!-- <p>
                {{ $t("homeStep2Text") }}
              </p> -->
            </figure>
          </li>
          <li class="landing-how__item" v-view>
            <div class="landing-how__title">
              <!-- Scan the QR code inside the bag to get redirected to the frame claim page -->
              バッジに封入されているQRコードをスキャンしますと、フレームのリクエストページに飛びます。
            </div>
            <figure class="landing-how__figure">
              <img src="../assets/howtoclaim/qr-bag.png" />
              <!-- <p>
                {{ $t("homeStep3Text") }}
              </p> -->
            </figure>
          </li>
          <li class="landing-how__item" v-view>
            <div class="landing-how__title">
              <!-- Click on "Claim Frame", if successful after a few seconds you will be redirected to your profile -->
              フレームをリクエストする」ボタンを押してください。正常に手続きが完了しますと、すぐにプロフィールにフレームコレクションが追加されます。
              </div>
            <figure class="landing-how__figure">
              <img src="../assets/howtoclaim/frame-ja.png" />
              <!-- <p>
                {{ $t("homeStep4Text") }}
              </p> -->
            </figure>
            
          </li>
        </ol>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: "home-how",
  methods: {

    getImg(filename) {
      const images = require.context("@/assets/home/", false, /\.png$/);
      // const images = require.context('@/assets/company/', false, /\.jpg$/)
      return images(
        `./${filename}-${this.$store.state.lang}.png`
      );
    },
    getImgUrl() {
      const images = require.context("@/assets/home/", false, /\.jpg$/);
      // const images = require.context('@/assets/company/', false, /\.jpg$/)
      return images(
        "./frame-browser-foujita-" + this.$store.state.lang + ".jpg"
      );
    },
    getCertImgUrl() {
      const images = require.context("@/assets/home/", false, /\.png$/);
      // const images = require.context('@/assets/company/', false, /\.jpg$/)
      return images(
        "./certificate-" + this.$store.state.lang + ".png"
      );
    },
  },
  computed: {
    frameBrowserImage() {
      console.log(this.$t("frameBrowserImage"));
      return this.$t("frameBrowserImage");
    },
  },
};
</script>
<style scoped lang="scss">
.references-text {
  font-style: 6px;
  text-align: center;
  padding-top: 15px;
}
/* unvisited link */
.link-text {
  color: var(--color-primary);
  font-weight: 600;
}

.benefits-image {
  border-radius: 5px;
  border-color: var(--color-primary);
  border-style: solid;
  border-width: thin;
}
.landing {
  background-color: var(--color-white);
  height: 100%;
  width: 100%;
  &__container {
    width: var(--main-width-container);
    margin: auto;
  }
}

.landing-flat {
  padding: 32px 16px;
  &:nth-child(2n) {
    background-color: var(--color-grey-light);
  }
  &__title {
    text-align: center;
    font-weight: 600;
    font-size: var(--font-size-3);
    margin-bottom: 48px;
  }
  &__intertitle {
    text-align: center;
    font-size: var(--font-size-4);
    font-weight: 300;
  }
}
// cta
.landing-cta {
  opacity: 0;
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 0);
  display: inline-block;
  border-radius: 4px;
  padding: 0.5em;
  font-weight: 900;
  font-size: clamp(1rem, 2.5vw, 2rem);
  color: var(--color-white);
  background-color: var(--color-primary);
  transition-duration: 0.3s;
  transition-property: transform;

  &:before {
    position: absolute;
    z-index: -1;
    content: "";
    top: 100%;
    left: 5%;
    height: 10px;
    width: 90%;
    opacity: 0;
    background: radial-gradient(
      ellipse at center,
      rgba(0, 0, 0, 0.35) 0%,
      rgba(0, 0, 0, 0) 80%
    );

    transition-duration: 0.3s;

    transition-property: opacity;
  }
  &:hover {
    z-index: 1;
    box-shadow: 0 0 1px rgb(0 0 0 / 0%);
    transform: translate(-50%, -5px);
    &:before {
      opacity: 1;
      transform: translateY(5px);
    }
  }

  &--animable {
    opacity: 0;
  }
  &.view-in--full {
    animation: opacityAnimation 400ms linear 400ms forwards;
  }
}


// secure
.landing-secure-block-wrap {
  position: relative;
  padding-bottom: 24px;
}


.fancy-border-radius-left,
.fancy-border-radius-right {
  --velocity: 500ms;
  margin: auto;
  width: 250px;
  height: 250px;
  transform: scale(0.1);
  background-color: var(--color-white);
  @media only screen and (min-width: 1024px) {
    width: 400px;
    height: 350px;
  }
}

.fancy-border-radius-left.view-in {
  animation: scaleAnimation var(--velocity) forwards;
}
.fancy-border-radius-right.view-in {
  animation: scaleAnimation var(--velocity) 100ms forwards;
}

.fancy-border-radius-left {
  border-radius: 74% 26% 59% 41% / 56% 27% 73% 44%;
}

.fancy-border-radius-right {
  border-radius: 25% 75% 24% 76% / 25% 25% 75% 75%;
}

.word-pulse {
  position: relative;
  display: inline-block;
  background-image: linear-gradient(
    90deg,
    var(--color-primary) 0%,
    var(--color-primary) 100%
  );
  background-size: cover;
  background-position: -1000px 0;
  &.view-in--full {
    animation: underlineWord 600ms linear 200ms forwards;
  }
}

// how
.landing-how {
  margin-top: 24px;
  list-style-type: none;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 128px;
  padding-left: 0;
  @media only screen and (min-width: 1400px) {
    grid-template-columns: 1fr 1fr;
  }
  li {
    min-height: 1px;
    counter-increment: section;
    position: relative;
    padding-left: 32px;
    // max-width: 360px;
    // margin: auto;
    // @media only screen and (min-width: 768px) {
      // max-width: initial;
    // }
    &:before {
      --velocity: 300ms;
      --delay: 200ms;
      content: counter(section);
      position: absolute;
      z-index: 0;
      top: 0;
      line-height: 0.8;
      font-size: 90px;
      font-weight: bold;
      color: var(--color-primary);
      font-family: sans-serif;
      left: -4px;
      text-align: center;
      transform: scale(0);
      transform-origin: center center;

      @media only screen and (min-width: 768px) {
        font-size: 120px;
        line-height: 1;
      }
    }
  }
  // @at-root .landing-flat-animated {
  .landing-how__item:first-child.view-in:before {
    // prettier-ignore
    animation: scaleAnimation var(--velocity) calc(var(--delay) * 1) forwards;
  }
  .landing-how__item:nth-child(2).view-in:before {
    // prettier-ignore
    animation: scaleAnimation var(--velocity) calc(var(--delay) * 2) forwards;
  }
  .landing-how__item:nth-child(3).view-in:before {
    // prettier-ignore
    animation: scaleAnimation var(--velocity) calc(var(--delay) * 3) forwards;
  }
  .landing-how__item:last-child.view-in:before {
    // prettier-ignore
    animation: scaleAnimation var(--velocity) calc(var(--delay) * 4) forwards;
  }
  // }
  
  &__title {
    position: relative;
    z-index: 1;
    font-size: 32px;
    line-height: 1;
    // max-width: 350px;
    @media only screen and (min-width: 768px) {
      font-size: 45px;
    }
  }
  &__item:nth-child(2n) {
    img {
      order: 1;
    }
  }

  &__figure {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    font-size: 16px;
    max-width: 240px;
    @media only screen and (min-width: 768px) {
      font-size: 24px;
      max-width: initial;
    }
    @media only screen and (min-width: 768px) {
      // height: 200px;
      flex-wrap: nowrap;
    }
    > * {
      @media only screen and (min-width: 768px) {
        flex-basis: 50%;
        width: 80%;
      }
    }
    img {
      margin-right: 24px;
      margin: auto;
      object-fit: contain;
      margin: 16px;
    }
    p {
      margin-top: 8px;
    }
  }
}

@keyframes scaleAnimation {
  80% {
    transform: scale(1.1);
  }
  to {
    transform: scale(1);
  }
}

@keyframes underlineWord {
  to {
    background-position: 0 0;
  }
}

@keyframes opacityAnimation {
  to {
    opacity: 1;
  }
}

// feature-works
.landing-works {
  padding: 0 16px 24px;
  position: relative;
}
.landing-feature-works {
  display: flex;
  align-items: center;
  justify-content: center;

  flex-direction: column;
  @media only screen and (min-width: 768px) {
    flex-direction: row;
  }
  li {
    margin-bottom: 32px;
    @media only screen and (min-width: 768px) {
      margin: 0 16px;
    }
    &:last-child {
      display: none;
      @media only screen and (min-width: 768px) {
        display: block;
      }
    }

    img {
      border-radius: 4px;
      width: 66vw;
      margin: auto;
      box-shadow: 0 16px 16px -1px rgba(10, 22, 70, 0.1),
        0 0 1px 0 rgba(10, 22, 70, 0.06);
      z-index: 1;
      @media only screen and (min-width: 480px) {
        width: 40vw;
      }
      @media only screen and (min-width: 768px) {
        width: 25vw;
      }
      @media only screen and (min-width: 1200px) {
        width: 15vw;
      }
    }
  }
}
</style>
